function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M70 50C58.958 50 50 58.958 50 70C50 81.042 58.958 90 70 90C81.042 90 90 81.042 90 70C89.9832 58.958 81.0252 50 70 50ZM78.3697 65.5294H77.1261L73.3109 69.9832L77.1261 74.437H78.3866V78.0168H70.2857V74.4706H71.5462L69.042 71.5462H68.0168V74.4706H69.4454V78.0168H61.5966V74.437H63.2941V70V65.5294H61.5966V61.9496H63.5294V63.2773H64.5714V61.9496H66.4706V63.2773H67.5126V61.9496H69.4286V65.479H68V68.4034H69.0252L71.5294 65.479H70.2689V61.9496H78.3697V65.5294Z",
  fill: "#48DBB4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "first-circle",
  strokeWidth: 1,
  cx: 70,
  cy: 70,
  r: 15,
  stroke: "#48DBB4"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "second-circle",
  strokeWidth: 1,
  cx: 70,
  cy: 70,
  r: 15,
  stroke: "#48DBB4"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "third-circle",
  strokeWidth: 1,
  cx: 70,
  cy: 70,
  r: 15,
  stroke: "#48DBB4"
});

const SvgKeepLoadingIndicator = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "keep-loading-indicator-icon",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKeepLoadingIndicator, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/keep-loading-indicator.78ca396b.svg";
export { ForwardRef as ReactComponent };